export default __webpack_public_path__ + "static/media/about_background_left.a8ca97cd.png";